import { render } from "./TeamRosterThurB.vue?vue&type=template&id=fa206b58&scoped=true"
import script from "./TeamRosterThurB.vue?vue&type=script&scoped=true&lang=js"
export * from "./TeamRosterThurB.vue?vue&type=script&scoped=true&lang=js"

import "./TeamRosterThurB.vue?vue&type=style&index=0&id=fa206b58&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jgurl\\KontraWebsite\\KontraSports\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa206b58"]])

export default __exports__